import { render, staticRenderFns } from "./SentEmails.vue?vue&type=template&id=1db5a2bb&"
import script from "./SentEmails.vue?vue&type=script&lang=ts&"
export * from "./SentEmails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports